import {
  GapOfferStatus,
  IAppointment,
  ICandidate,
  IPatient,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  DocumentReference,
  INamedDocument,
  MockTimestamp,
  Properties,
  Timestamp,
} from '@principle-theorem/shared';
import { MockDocRef, MockNamedDocument } from '@principle-theorem/testing';

export class CandidateMock
  extends BaseFirestoreMock<Properties<ICandidate>>
  implements Properties<ICandidate>
{
  get appointment(): DocumentReference<IAppointment> {
    return MockDocRef<IAppointment>();
  }

  get patient(): INamedDocument<IPatient> {
    return MockNamedDocument<IPatient>();
  }

  get status(): GapOfferStatus {
    return GapOfferStatus.Available;
  }

  get offerTimeFrom(): Timestamp {
    return MockTimestamp();
  }

  get offerTimeTo(): Timestamp {
    return MockTimestamp();
  }
}
